import { POST_VENDORS_SUCCESS } from 'modules/authorizations/types';
import {
  GET_ALL_BROKER_AGENTS_FAILURE,
  GET_ALL_BROKER_AGENTS_REQUEST,
  GET_ALL_BROKER_AGENTS_SUCCESS,
  GET_EXPENSE_CODES_BY_CLIENT_ID_SUCCESS,
  GET_EXPENSE_CODES_SUCCESS,
  GET_INSPECTORS_FAILURE,
  GET_INSPECTORS_REQUEST,
  GET_INSPECTORS_SUCCESS,
  GET_TAX_POLICIES_FAILURE,
  GET_TAX_POLICIES_REQUEST,
  GET_TAX_POLICIES_SUCCESS,
  GET_TITLE_REP_FAILURE,
  GET_TITLE_REP_REQUEST,
  GET_TITLE_REP_SUCCESS,
  GET_VENDORS_SUCCESS,
  GET_VENDOR_CONTACT_SUCCESS,
  GET_VENDOR_DOCUMENTS_SUCCESS,
  GET_VENDOR_BANKING_INFO_BY_VENDOR_ID_SUCCESS,
  UPDATE_VENDOR_DETAILS_SUCCESS,
  GET_VENDOR_NOTES_SUCCESS,
  GET_VENDOR_HISTORY_SUCCESS,
  SET_VENDOR_ID,
  GET_VENDOR_DETAILS_SUCCESS,
  POST_VENDOR_CONTACT_SUCCESS,
  UPDATE_VENDOR_CONTACT_SUCCESS,
  DELETE_VENDOR_CONTACT_SUCCESS,
  POST_VENDOR_DOCUMENT_SUCCESS,
  UPDATE_VENDOR_DOCUMENT_SUCCESS,
  DELETE_VENDOR_DOCUMENT_SUCCESS,
  POST_VENDOR_BANKING_INFO_SUCCESS,
  UPDATE_VENDOR_BANKING_INFO_SUCCESS,
  DELETE_VENDOR_BANKING_INFO_SUCCESS
} from '../types/dataManagementTypes';

const handleDataManagementReducer = (draft, action) => {
    if (!draft.vendorDetails[draft.currentVendorId]) draft.vendorDetails[draft.currentVendorId] = {};
  switch (action.type) {
    case GET_ALL_BROKER_AGENTS_REQUEST:
      draft.brokerAgentsLoading = true;
      break;

    case GET_ALL_BROKER_AGENTS_SUCCESS:
      draft.brokerAgentsLoading = false;
      draft.brokerAgents = action.response;
      break;

    case GET_ALL_BROKER_AGENTS_FAILURE:
      draft.brokerAgentsLoading = false;
      break;

    case GET_TAX_POLICIES_REQUEST:
      draft.taxPoliciesLoading = true;
      break;

    case GET_TAX_POLICIES_FAILURE:
      draft.taxPoliciesLoading = false;
      break;

    case GET_TAX_POLICIES_SUCCESS:
      draft.taxPolicies = action.response;
      draft.taxPoliciesLoading = false;
      break;

    case GET_INSPECTORS_REQUEST:
      draft.isInspectorsLoading = true;
      break;

    case GET_INSPECTORS_SUCCESS:
      draft.inspectors = action.response;
      draft.isInspectorsLoading = false;
      break;

    case GET_INSPECTORS_FAILURE:
      draft.isInspectorsLoading = false;
      break;

    case GET_EXPENSE_CODES_SUCCESS:
    case GET_EXPENSE_CODES_BY_CLIENT_ID_SUCCESS:
      draft.expenseCodes = action.response;
      break;

    case GET_TITLE_REP_REQUEST:
      draft.isTitleRepIsLoading = true;
      break;

    case GET_TITLE_REP_SUCCESS:
      draft.titleReps = action.response;
      draft.isTitleRepIsLoading = false;
      break;

    case GET_TITLE_REP_FAILURE:
      draft.isTitleRepIsLoading = false;
      break;

      // VENDORS

    case SET_VENDOR_ID:
      draft.currentVendorId = action.response;
      break;

    case GET_VENDORS_SUCCESS:
    case POST_VENDORS_SUCCESS:
      draft.vendors = action.response;
      break;

    case GET_VENDOR_DETAILS_SUCCESS: 
      draft.vendorDetails[draft.currentVendorId] = action.response;
      break;

    case GET_VENDOR_HISTORY_SUCCESS:
      draft.vendorHistory = action.response;
      break;

    case GET_VENDOR_NOTES_SUCCESS:
      draft.vendorAuthNotes = action.response;
      break;

    case GET_VENDOR_CONTACT_SUCCESS:
      draft.vendorContacts = action.response;
      break;
    
    case POST_VENDOR_CONTACT_SUCCESS:
    case UPDATE_VENDOR_CONTACT_SUCCESS:
    case DELETE_VENDOR_CONTACT_SUCCESS:
      draft.vendorDetails[draft.currentVendorId].contacts = action.response;
      break;

    case GET_VENDOR_DOCUMENTS_SUCCESS:
    case POST_VENDOR_DOCUMENT_SUCCESS:
    case UPDATE_VENDOR_DOCUMENT_SUCCESS:
    case DELETE_VENDOR_DOCUMENT_SUCCESS:
      draft.vendorDetails[draft.currentVendorId].attachments = action.response;
      break;

    case GET_VENDOR_BANKING_INFO_BY_VENDOR_ID_SUCCESS:
    case POST_VENDOR_BANKING_INFO_SUCCESS:
    case UPDATE_VENDOR_BANKING_INFO_SUCCESS:
    case DELETE_VENDOR_BANKING_INFO_SUCCESS:
      draft.vendorDetails[draft.currentVendorId].banks = action.response;
      break;      

    case UPDATE_VENDOR_DETAILS_SUCCESS: 
      draft.vendorDetails[draft.currentVendorId] = action.response;
      break;

    default:
      break;
  }
  return draft;
};

export default handleDataManagementReducer;
